import { getSubscriptionPlanDetals, DeleteLeaveRequest, accountSubscription, orgSubscriptioDetails, HEADERS } from '../pages/api';
import axios from 'axios';

export default async function getSubscriptionDetails() {
    try {
        const response = await axios.post(
            getSubscriptionPlanDetals,
            {},
            { headers: HEADERS }
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw new Error('Failed to fetch data');
    }
}

export async function registerPaidSubscription(payload) {
    try {
        const response = await axios.post(
            accountSubscription,
            payload,
            { headers: HEADERS }
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
}

export async function organisationSubsDetails(org_id) {
    try {
        const response = await axios.post(
            orgSubscriptioDetails,
            org_id,
            { headers: HEADERS }
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
}
export async function deleteLeaveRequest(data) {
    try {
        console.log('Sending request to delete leave:', data); 
        const response = await axios.post(DeleteLeaveRequest, data, { headers: HEADERS });
        return response.data;
    } catch (error) {
        console.error('Error deleting leave request:', error);
        throw error;
    }
}







